module.exports = __webpack_public_path__ + "static/feature-places@2x-5c57494ab1b48f2052dd2d0860ec4c2e.gif";